/* eslint-disable no-empty-pattern */
import { MenuItem, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { accounts } from '../../../frontend-config';
export var AccountSelector = function (_a) {
    var onValueChange = _a.onValueChange, initialValue = _a.initialValue, fullWidth = _a.fullWidth, noAll = _a.noAll, disabled = _a.disabled;
    var _b = useState(accounts[0].url), account = _b[0], setAccount = _b[1];
    useEffect(function () {
        if (initialValue === 'All') {
            setAccount('All');
        }
        else if (initialValue) {
            setAccount(initialValue.url);
        }
        else {
            setAccount(accounts[0].url);
        }
    }, [initialValue]);
    var handleValueChange = function (_account) {
        setAccount(_account);
        if (_account === 'All') {
            onValueChange('All');
        }
        else {
            onValueChange(accounts.find(function (a) { return a.url === _account; }));
        }
    };
    return (React.createElement(TextField, { select: true, value: account, onChange: function (e) { return handleValueChange(e.target.value); }, variant: 'outlined', size: 'small', fullWidth: fullWidth, disabled: disabled },
        !noAll && (React.createElement(MenuItem, { key: 'all', value: 'All' }, "All")),
        accounts.map(function (option) { return (React.createElement(MenuItem, { key: option.shortCode, value: option.url }, option.name)); })));
};
AccountSelector.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=AccountSelector.js.map